// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1620": "809898e6dadc","5336": "5083bc5218c4","6863": "454c9f289029","7660": "334d5378c452","8357": "dd422574e14d",}[chunkId] + ".css"
}